import React from 'react';

import classNames from 'classnames';
import { ReactComponent as GripLines } from 'components/svg/icons/grip-lines.svg';
import PropTypes from 'prop-types';

const DragHandler = ({ className, ...others }) => {
  const stopPropagation = (e) => e.stopPropagation();

  return (
    <span
      className={classNames(
        'ca-drag-handler',
        '_d-flex _align-items-center _justify-content-center _text-gray-400',
        className
      )}
      onClick={stopPropagation}
      data-test="ca-drag-handler"
      {...others}
    >
      <GripLines data-test="ca-drag-handler-icon" />
    </span>
  );
};

DragHandler.propTypes = {
  className: PropTypes.string
};

export default DragHandler;
